import { AxiosInstance } from "axios";
import { ApiService } from "../model/Api.model";

enum TradeDocumetServiceEnum {
    GetDocuments = "/get-documents/",
    sendTransferTerm = "/awaiting-transfer-term-upload",
    sendTerm = "/term-upload",
}

export default class TradeDocumetService extends ApiService {
    constructor(restClient: AxiosInstance) {
        super(restClient, "/trade/document");
    }

    public GetDocuments = async (tradeId: number): Promise<any[]> => await this.GET(TradeDocumetServiceEnum.GetDocuments + tradeId, null);
    public sendTransferTerm = async (payload: any) => await this.POST(TradeDocumetServiceEnum.sendTransferTerm, payload);
    public sendTerm = async (payload: any) => await this.POST(TradeDocumetServiceEnum.sendTerm, payload);
}


// WEBPACK FOOTER //
// ./src/services/api/TradeDocumet.service.ts